<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/IDTs">
                Financial Services
            </b-breadcrumb-item>
            <b-breadcrumb-item active>Computer Assets</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Assets</div>
            <div class="card-body">
              
                <!-- The collapsable filter options -->
                <AppFormCardCollapsable :display-footer="true" @submit.prevent="onFilterSubmit()" class="mb-3">
                    <template v-slot:header>Filter</template>
                    <template v-slot:body>
                        <div class="form-row justify-content-center">
                            <div class="col form-group">
                                <label for="assetNumber">Asset Number</label>
                                <input
                                        class="form-control"
                                        placeholder="Asset Number"
                                        v-model="filterOptions.assetNumber"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="serialNumber">Serial Number</label>
                                <input
                                        class="form-control"
                                        placeholder="Serial Number"
                                        v-model="filterOptions.serialNumber"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="manufacturer">Manufacturer</label>
                                <input
                                        class="form-control"
                                        placeholder="Manufacturer"
                                        v-model="filterOptions.manufacturer"
                                />
                            </div>
                            <div class="col form-group">
                                <label for="modelNumber">Model Number</label>
                                <input
                                        class="form-control"
                                        placeholder="Model Number"
                                        v-model="filterOptions.modelNumber"
                                />
                            </div>
                            <div class="col-auto form-group">
                                <label for="vendor">Vendor</label>
                                <input
                                        class="form-control"
                                        placeholder="Vendor"
                                        v-model="filterOptions.vendor"
                                />
                            </div>
                            <div class="col-md-4 col-sm-6 form-group align-self-center">
                                <b-form-checkbox
                                                v-model="filterOptions.existsInFamis"
                                                :value="true"
                                                :unchecked-value="false"
                                              >
                                                Only show Assets Existing in FAMIS
                                            </b-form-checkbox>
                            </div>
                            <div class="col-md-4 col-sm-6 form-group align-self-center">
                                <b-form-checkbox
                                                v-model="filterOptions.onlyShowDataIssues"
                                                :value="true"
                                                :unchecked-value="false"
                                              >
                                                Only Show Data with Issues
                                            </b-form-checkbox>
                            </div>
                        </div>
                    </template>
                    <template v-slot:footer>
                        <button class="btn btn-primary" type="submit">Apply</button>
                    </template>
                </AppFormCardCollapsable>
                <div class="d-print-none dropdown mb-3 text-right">
                    <button :disabled="isPerformingAction" aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                            data-toggle="dropdown" style="width: 100px" type="button">
                        <span>Actions</span>
                    </button>
                    <div class="dropdown-menu">
                        <RouterLink :to="{name: 'AddComputerAsset'}" class="btn btn-outline-light dropdown-item text-left"
                                    title="Add New Computer Asset">
                            <i class="fa fa-plus"></i>Add
                        </RouterLink>
                        <a @click.prevent="downloadCsvExport()" class="btn btn-outline-light dropdown-item text-left"
                            href="javascript:void(0)" title="Export active computer assets list to a CSV">
                            <i class="fa fa-file-excel"></i>Download Active Computer Assets .csv
                        </a>
                    </div>
                </div>
                <BTable :busy="isLoading"
                        :fields="tableFields"
                        :items="computerAssets"
                        :responsive="true"
                        primary-key="id"
                        show-empty
                        striped
                        table-class="table-align-middle">

                    <template v-slot:cell(id)="row">
                      <div class="row">
                        <div class="col-auto">
                          <a @click="toggleDetails(row)" class="ml-3">
                            <i v-if="!row.item._showDetails" class="fa fa-caret-down fa-lg" />
                            <i v-if="row.item._showDetails" class="fa fa-caret-up fa-lg" />
                          </a>
                        </div>
                        <div class="btn-group col-auto">
                            <router-link
                                    :to="{ name:'EditComputerAsset', params:{ id: row.item.id } }"
                                    class="btn btn-sm btn-warning d-print-none"
                                    data-toggle="tooltip"
                                    title="Edit computer asset">
                                <i class="fa fa-pencil-alt"></i>Edit
                            </router-link>
                        </div>
                      </div>
                    </template>

                    <template v-slot:cell(assetNumber)="row">
                        <i v-if="row.item.organizationCode == null || row.item.custodianPersonName == null || row.item.organizationId == null || row.item.custodianPersonId == null || (row.item.organizationIsActive != null && !row.item.organizationIsActive) || (row.item.custodianIsActive != null && !row.item.custodianIsActive)" class="fa fa-exclamation-circle" style="color: red !important;display:inline;padding-right:5px;"></i>
                        <span>{{ row.item.assetNumber}}</span>
                    </template>

                    <template v-slot:row-details="row">
                        <b-container>
                            <div>
                                <fieldset v-if="row.item.organizationCode == null || row.item.custodianPersonName == null || row.item.organizationId == null || row.item.custodianPersonId == null || (row.item.organizationIsActive != null && !row.item.organizationIsActive) || (row.item.custodianIsActive != null && !row.item.custodianIsActive)" class="border p-3 mr-2">
                                    <legend class="w-auto h5">Sync Data Issues</legend>
                                    <b-row>
                                        <b-col>
                                            <div class="font-weight-bold">FAMIS Missing Organization</div>
                                            <div class="pl-4">{{ row.item.organizationCode == null ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">FAMIS Missing Custodian</div>
                                            <div class="pl-4">{{ row.item.custodianPersonName == null ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">BIMS Missing Organization</div>
                                            <div class="pl-4">{{ row.item.organizationId == null ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">BIMS Missing Custodian</div>
                                            <div class="pl-4">{{ row.item.custodianPersonId == null ? "Yes" : "No" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">Organization Inactive</div>
                                            <div class="pl-4">{{ row.item.organizationId == null ? "Unkown" :  row.item.organizationIsActive ? "No" : "Yes" }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">Custodian Inactive</div>
                                            <div class="pl-4">{{ row.item.custodianPersonId == null ? "Unkown" :  row.item.custodianIsActive ? "No" : "Yes" }}</div>
                                        </b-col>
                                    </b-row>
                                </fieldset>
                                <br>
                            </div>

                            <div>
                                <fieldset class="border p-3 mr-2">
                                    <legend class="w-auto h5">Details</legend>
                                    <b-row>
                                        <b-col>
                                            <div class="font-weight-bold">Vendor</div>
                                            <div class="pl-4">{{ row.item.vendor }}</div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <div class="font-weight-bold">Purchase Amount</div>
                                            <div class="pl-4">{{ row.item.purchaseAmount | currency }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">Purchase Date</div>
                                            <div class="pl-4">{{ row.item.purchaseDate | moment('MM/DD/YYYY') }}</div>
                                        </b-col>
                                    </b-row>
                                    <b-row>
                                        <b-col>
                                            <div class="font-weight-bold">Organization</div>
                                            <div class="pl-4">{{ row.item.organizationCode }}</div>
                                        </b-col>
                                        <b-col>
                                            <div class="font-weight-bold">Custodian</div>
                                            <div class="pl-4">{{ row.item.custodianPersonName }}</div>
                                        </b-col>
                                    </b-row>
                                </fieldset>
                                <br>
                            </div>
                        </b-container>
                    </template>

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalComputerAssets"
                                        v-on:update:page="loadData()"
                                        v-on:update:pageSize="loadData()"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>
                </BTable>
            </div>
        </div>
    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import AppTablePagination from "../../components/shared/AppTablePagination";
    import AppFormCardCollapsable from "@/components/shared/AppFormCardCollapsable";
    import ComputersService from "@/services/ComputersService";
    import {currency} from "../../filters/Currency";

    export default {
        components: {
            AppTablePagination,
            AppFormCardCollapsable
        },
        filters: {
            currency
        },
        data() {
            return {
                isPerformingAction: false,
                computerAssets: [],
                totalComputerAssets: 0,
                filterOptions: {
                    page: 1,
                    pageSize: 10,
                    returnAll: false,
                    assetNumber: null,
                    serialNumber: null,
                    manufacturer: null,
                    modelNumber: null,
                    description: null,
                    vendor: null,
                    existsInFamis: false,
                    famisStatus: "Active",
                    onlyShowDataIssues: false
                },
                isLoading: false,
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:150px'
                    }, 
                    {
                        key: 'assetNumber',
                        label: 'Asset Number'
                    },
                    {
                        key: 'serialNumber',
                        label: 'Serial Number'
                    },
                    {
                        key: 'description',
                        label: 'Description',
                    },
                    {
                        key: 'manufacturer',
                        label: 'Manufacturer',
                    },
                    {
                        key: 'modelNumber',
                        label: 'Model Number',
                    },
                    {
                        key: 'famisStatus',
                        label: 'FAMIS Status'
                    }
                ]
            }
        },
        methods: {
            /**
             * @description Resets the page to the first page and reloads the data
             */
            onFilterSubmit() {
                this.filterOptions.page = 1;
                this.loadData();
            },
            
            loadData() {
                const vm = this;
                vm.isLoading = true;

                ComputersService.getComputerAssets(vm.filterOptions)
                  .then(response => {
                    vm.computerAssets = response.data.map(obj => ({ ...obj, _showDetails: false }));
                    vm.totalComputerAssets = response.totalCount;
                  })
                  .catch(() => {
                    vm.redirectToError()
                  })
                  .finally(() => {
                    vm.isLoading = false;
                  })
            },

            toggleDetails (row) {
              if (!row.item._showDetails) {
                row.item._showDetails = true;
              } else {
                row.item._showDetails = false;
              }
            },

            /**
             * @description Downloads the computer assets CSV export to the user's browser
             */
            downloadCsvExport() {
                this.isPerformingAction = true;
                const vm = this;

                ComputersService.getComputerAssetsExcelExport()
                    .catch(error => {
                        vm.alert(ToastType.Danger, error.response.statusText)
                    })
                    .finally(() => {
                        this.isPerformingAction = false
                    });
            },
        },
        created() {
            this.loadData();
        }
    }
</script>
